import { useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Sparkles, Search } from "lucide-react";
import { toast } from "sonner";

export const SmartSearch = () => {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const run = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/smart-search", { query: q });
      const params = new URLSearchParams();
      Object.entries(data.filters || {}).forEach(([k, v]) => { if (v) params.set(k, v); });
      params.set("q", q);
      toast.success(
        Object.keys(data.filters || {}).length
          ? `Parsed: ${Object.entries(data.filters).map(([k, v]) => `${k}=${v}`).join(" · ")}`
          : "Searching…"
      );
      nav(`/listings?${params.toString()}`);
    } catch {
      toast.error("Could not parse your search");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={run} className="relative" data-testid="smart-search">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-1 pointer-events-none">
        <Sparkles className="w-4 h-4 text-[var(--primary)]" />
      </div>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder='Try "3bhk under 1 Cr near Infosys" or "cheap 2bhk rent Gokulam"'
        className="w-full pl-12 pr-32 py-4 rounded-full bg-white border border-[var(--line)] shadow-sm focus:outline-none focus:border-[var(--primary)] text-sm"
        data-testid="smart-search-input"
      />
      <button
        type="submit"
        disabled={busy || !q.trim()}
        className="absolute right-2 top-1/2 -translate-y-1/2 btn-primary py-2 px-4"
        data-testid="smart-search-btn"
      >
        {busy ? "Thinking…" : (
          <>
            <Search className="w-3.5 h-3.5" /> Smart Search
          </>
        )}
      </button>
    </form>
  );
};
